import { fetchShopOrderUnreadCount } from '@/api/pointShop'

function normalizeCount(value) {
  const count = Number(value)
  return Number.isFinite(count) ? Math.max(0, Math.floor(count)) : 0
}

const state = {
  unreadCount: 0,
  revision: 0,
  refreshRequestId: 0
}

const mutations = {
  SET_UNREAD_COUNT(state, count) {
    state.unreadCount = normalizeCount(count)
    state.revision += 1
  },
  START_REFRESH(state, requestId) {
    state.refreshRequestId = requestId
  },
  APPLY_REFRESH(state, payload) {
    if (payload.requestId !== state.refreshRequestId || payload.revision !== state.revision) {
      return
    }
    state.unreadCount = normalizeCount(payload.count)
  }
}

const actions = {
  refreshUnreadCount({ commit, state }) {
    const requestId = state.refreshRequestId + 1
    const revision = state.revision
    commit('START_REFRESH', requestId)

    return fetchShopOrderUnreadCount().then(data => {
      commit('APPLY_REFRESH', {
        requestId,
        revision,
        count: data && data.unread_count
      })
      return data
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
